module.exports = __webpack_public_path__ + "img/code1.bbd91413.jpg";